import React, { useState } from 'react';

import CreateWorkModal from '@atom/components/common/createWorkModals/CreateWorkModal';
import { Icon, Tooltip } from '@atom/mui';

const WorkOrdersCalendarCell = props => {
  const { children, value } = props;
  const [hovering, setHovering] = useState(false);
  const [workModalOpen, setWorkModalOpen] = useState(false);

  const styles = {
    container: {
      position: 'relative',
    },
    iconStyle: {
      display: hovering ? 'block' : 'none',
      cursor: 'pointer',
      position: 'absolute',
      bottom: 0,
      right: 0,
    },
  };

  return (
    <>
      <div
        onMouseEnter={() => setHovering(true)}
        onMouseLeave={() => setHovering(false)}
        className={children.props.className}
        style={styles.container}
      >
        {children}
        <Tooltip title="Create Work">
          <div onClick={() => setWorkModalOpen(true)} style={styles.iconStyle}>
            <Icon>add</Icon>
          </div>
        </Tooltip>
      </div>
      <CreateWorkModal
        fromCalendarDate={value}
        open={workModalOpen}
        workTemplateRequired
        onClose={() => setWorkModalOpen(false)}
        redirectOnCreate
      />
    </>
  );
};

export default WorkOrdersCalendarCell;
